module.exports = __webpack_public_path__ + "static/img/cop_sch_logo3.86cbbe4f.png";